export function isExternalLink(link: string): boolean {
    return /^https:\/\//.test(link);
}
